var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168 84C168 130.392 130.392 168 84 168C37.6081 168 0 130.392 0 84C0 37.6081 37.6081 0 84 0C130.392 0 168 37.6081 168 84ZM83.6695 31C67.282 31 53.982 44.3 53.982 60.6872C53.982 76.758 66.5695 89.8205 83.2736 90.2955H83.9861H84.5403H84.6986C100.69 89.7413 113.278 76.758 113.357 60.6872C113.357 44.3 100.057 31 83.6695 31ZM83.675 150.305C104.417 150.305 123.258 142.309 137.35 129.326C135.45 122.121 130.383 115.551 122.783 110.484C101.329 96.0755 66.1792 96.0755 44.5667 110.484C37.0458 115.551 31.9 122.121 30 129.326C44.0917 142.309 62.9333 150.305 83.675 150.305Z",
    fill: "#E12653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.87727ed6a5cea6629ce3bf04b6b88c67.svg";
export { ForwardRef as ReactComponent };